import Axios from "../config/config";


//COURSE API
export const ADD_COURSE = async (body) => {
    try {
        const response = await Axios.post('add-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_COURSE = async (body) => {
    try {
        const response = await Axios.post('edit-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_COURSE = async (body) => {
    try {
        const response = await Axios.post('view-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const COURSE_LIST = async (body) => {
    try {
        const response = await Axios.post('course-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETED_COURSE_LIST = async (body) => {
    try {
        const response = await Axios.post('list-deleted-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const COURSE_STATUS = async (body) => {
    try {
        const response = await Axios.post('course-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_COURSE = async (body) => {
    try {
        const response = await Axios.post('delete-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const BULK_ASSIGN_COURSE = async (body) => {
    try {
        const response = await Axios.post('bulk-assign-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
